// src/components/Documentation/data/parameters.js

export const screenshotParameters = [
  {
    name: 'url',
    type: 'string',
    required: true,
    default: '-',
    description: 'The URL of the website to capture',
    plan: 'free'
  },
  {
    name: 'width',
    type: 'integer',
    required: false,
    default: '1920',
    description: 'Viewport width in pixels (320-3840)',
    plan: 'free'
  },
  {
    name: 'height',
    type: 'integer',
    required: false,
    default: '1080',
    description: 'Viewport height in pixels (240-2160)',
    plan: 'free'
  },
  {
    name: 'fullPage',
    type: 'boolean',
    required: false,
    default: 'false',
    description: 'Capture the entire page length',
    plan: 'starter'
  },
  {
    name: 'format',
    type: 'string',
    required: false,
    default: 'png',
    description: 'Image format: png, jpeg (Free+), or webp (Starter+)',
    plan: 'free'
  },
  {
    name: 'quality',
    type: 'integer',
    required: false,
    default: '90',
    description: 'Image quality (1-100, for jpeg/webp only)',
    plan: 'free'
  },
  {
    name: 'blockAds',
    type: 'boolean',
    required: false,
    default: 'false',
    description: 'Block advertisements and tracking scripts',
    plan: 'growth'
  },
  {
    name: 'blockCookieBanners',
    type: 'boolean',
    required: false,
    default: 'false',
    description: 'Automatically dismiss cookie consent banners',
    plan: 'growth'
  },
  {
    name: 'darkMode',
    type: 'boolean',
    required: false,
    default: 'false',
    description: 'Enable dark mode if supported by the site',
    plan: 'free'
  },
  {
    name: 'hideElements',
    type: 'array',
    required: false,
    default: '[]',
    description: 'CSS selectors of elements to hide',
    plan: 'growth'
  },
  {
    name: 'customCSS',
    type: 'string',
    required: false,
    default: '""',
    description: 'Custom CSS to inject into the page',
    plan: 'growth'
  },
  {
    name: 'customJS',
    type: 'string',
    required: false,
    default: '""',
    description: 'Custom JavaScript to execute before capture',
    plan: 'growth'
  }
];

export const deviceOptions = [
  'iPhone 14 Pro',
  'iPhone 14',
  'iPad Pro',
  'Samsung Galaxy S23',
  'Pixel 7',
  'Desktop (1920x1080)'
];

export const pdfParameters = [
  {
    name: 'url',
    type: 'string',
    required: false,
    default: '-',
    description: 'URL to generate PDF from (required if html not provided)'
  },
  {
    name: 'html',
    type: 'string',
    required: false,
    default: '-',
    description: 'HTML content to generate PDF from (required if url not provided)'
  },
  {
    name: 'format',
    type: 'string',
    required: false,
    default: 'A4',
    description: 'Page format: A4, Letter, Legal, A3, Tabloid'
  },
  {
    name: 'margin',
    type: 'object',
    required: false,
    default: '{}',
    description: 'Page margins {top, bottom, left, right}'
  },
  {
    name: 'landscape',
    type: 'boolean',
    required: false,
    default: 'false',
    description: 'Use landscape orientation'
  },
  {
    name: 'printBackground',
    type: 'boolean',
    required: false,
    default: 'true',
    description: 'Include background graphics'
  }
];